// service to help validate form input

export default {
  itShouldBeDefined(value) {
    return value !== null;
  },

  itShouldHaveOnlyDigits(value) {
    return /^[0-9]+$/.test(value);
  },

  itShouldHaveLengthExactly(value, conditon = 0) {
    return String(value).length === conditon;
  },

  itShouldBeNumberBetween(value, condition = [0, 0]) {
    if (!this.itShouldHaveOnlyDigits(value)) return false;
    return Number(value) >= condition[0] && Number(value) <= condition[1];
  },

  itShouldNotBeenStartedWith(value, condition = '') {
    if (!this.itShouldHaveOnlyDigits(value)) return false;
    return String(value).substr(0, condition.length) !== condition;
  },
};
